import React, { Component } from 'react';
import { StyledHeader } from '../styles';
import ParnerLogo from '../../Content/Shared/PartnerLogo';

class NimlyHeader extends Component {
  render() {
    return (
      <StyledHeader background="#2D5A50" boxShadow="none">
        <ParnerLogo
          getTranslation={(messageCode) => this.props.getTranslation(messageCode)}
          isHeaderLogo={true}
        />
      </StyledHeader>
    );
  }
}

export default NimlyHeader;
